import { render, staticRenderFns } from "./LvUserCard.vue?vue&type=template&id=21f77cef"
import script from "./LvUserCard.vue?vue&type=script&lang=js"
export * from "./LvUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports